import type { TableColumnMeta } from '../common/ColumnSelector';

/** Metadata describing a single device-list column, used by the column
 *  selector and the column-visibility hook. Every table shares the shape. */
export type DeviceColumnMeta = TableColumnMeta;

/** Column catalogue for the device list, grouped by category. */
export const DEVICE_COLUMN_METADATA: DeviceColumnMeta[] = [
  { id: 'select', label: 'Select', category: 'Actions', alwaysVisible: true },
  { id: 'name', label: 'Device Name', category: 'Basic Info' },
  { id: 'customerName', label: 'Customer', category: 'Basic Info' },
  { id: 'location', label: 'Location', category: 'Basic Info' },
  { id: 'status', label: 'Status', category: 'Basic Info' },
  { id: 'registrationStatus', label: 'Registration', category: 'Security' },
  { id: 'registrationId', label: 'Registration ID', category: 'Security' },
  { id: 'macAddress', label: 'MAC Address', category: 'Network' },
  { id: 'macBasedSerial', label: 'MAC-based Serial', category: 'Network' },
  { id: 'secureSerial', label: 'Secure Serial', category: 'Security' },
  { id: 'secureCode', label: 'Secure Code', category: 'Security' },
  { id: 'totalDiskGb', label: 'Disk Capacity', category: 'Hardware' },
  { id: 'groupName', label: 'Group', category: 'Metadata' },
  { id: 'hardware.model', label: 'Model', category: 'Hardware' },
  { id: 'clientVersion', label: 'Client Version', category: 'Hardware' },
  { id: 'comnovoGatewayVersion', label: 'Comnovo Version', category: 'Hardware' },
  { id: 'dpsEnvironment', label: 'DPS Environment', category: 'Azure IoT' },
  { id: 'dpsEnrollmentStatus', label: 'DPS Enrollment', category: 'Azure IoT' },
  { id: 'gsmStatus', label: 'GSM Modem', category: 'Hardware' },
  { id: 'network.ipAddress', label: 'IP Address', category: 'Network' },
  { id: 'lastSeen', label: 'Last Seen', category: 'Basic Info' },
  { id: 'actions', label: 'Actions', category: 'Actions', alwaysVisible: true },
];

/**
 * The columns worth seeing at a glance. Kept short enough to fit a laptop
 * screen without horizontal scrolling - everything else is one click away in
 * the column selector.
 */
export const DEVICE_DEFAULT_COLUMNS = [
  'select',
  'name',
  'customerName',
  'location',
  'status',
  'registrationStatus',
  'hardware.model',
  'clientVersion',
  'lastSeen',
  'actions',
];
